import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  sourceType: validator('presence', true),
  articleNumber: validator('presence', true),
  headline: validator('presence', true),
  artist: validator('presence', true),
});

export default class DigitalOrderConfigModel extends Model.extend(Validations) {
  @attr('string') sourceType;
  @attr('string') articleNumber;
  @attr('string') headline;
  @attr('string') artist;
  @attr('string') articleImageUrl;
  @attr('string') voucherUrl;
  @attr('string') campaign;
  @attr releaseDate;
  @belongsTo('asset', { async: true, inverse: null }) downloadAsset;
  @attr('string') validityPeriod;
  @attr('boolean', { defaultValue: false }) watermark;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return this.headline;
  }
}
